import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discoverButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'jolt.jira-side-nav-rovo-dev-adoption-ipm.cli.heading',
		defaultMessage: 'AI for software teams, now live in your terminal',
		description:
			"Heading displayed in the Rovo Dev adoption in-product message in the Jira side navigation. This variant promotes Rovo Dev's CLI capabilities specifically, highlighting availability in terminal environments.",
	},
	discoverButton: {
		id: 'jolt.jira-side-nav-rovo-dev-adoption-ipm.cli.discover-button',
		defaultMessage: 'Discover Rovo Dev CLI',
		description:
			'Label for the primary call-to-action button in the Rovo Dev adoption in-product message displayed in the Jira side navigation. Invites users to learn more about and start using Rovo Dev CLI.',
	},
});
